export default __webpack_public_path__ + "static/media/q3_step4.33dd1c08.png";